export default {
    data() {
        return {
            monthName: {
                1: "января",
                2: "февраля",
                3: "марта",
                4: "апреля",
                5: "мая",
                6: "июня",
                7: "июля",
                8: "августа",
                9: "сентября",
                10: "октября",
                11: "ноября",
                12: "декабря",
            },
        }
    },

    methods: {
        setZeros(number, signs = 2) {
            let res = String(number);
            if (number < Math.pow(10, signs - 1)) res = "0" * (signs - 1) + res;
            return res;
        },

        cycle(min, value, max) {
            if (value < min) return max - (min - value);
            if (value > max) return min + (value - max);
            return value;
        },

        convertDate(date) {
            let convertedDate = date.split("T")[0].split("-").reverse().join(".")
            if (date.includes("T")) convertedDate += (" " + date.split("T")[1]);
            return convertedDate;
        },

        getYMD(date) {
            return {
                year: date.getFullYear(),
                month: this.setZeros(date.getMonth() + 1),
                day: this.setZeros(date.getDate()),
            }
        },

        getHMS(date) {
            return {
                hours: this.setZeros(date.getHours()),
                minutes: this.setZeros(date.getMinutes()),
                seconds: this.setZeros(date.getSeconds()),
            }
        },

        fromDateToISO(date) {
            let { year, month, day } = this.getYMD(date);

            let { hours, minutes, seconds } = this.getHMS(date);
            let milliseconds = date.getMilliseconds();

            return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}Z`;
        },

        dateForYMDFormat(date) {
            let { year, month, day } = this.getYMD(date);

            return `${year}-${month}-${day}`;
        },

        dateForDMYFormat(date) {
            let { year, month, day } = this.getYMD(date);

            return `${day}.${month}.${year}`;
        },

        dateForDMYHMFormat(date) {
            let { hours, minutes } = this.getHMS(date);

            return this.dateForDMYFormat(date) + ` ${hours}:${minutes}`;
        },

        dateForYMDHMSFormat(date) {
            let { hours, minutes, seconds } = this.getHMS(date);

            return this.dateForYMDFormat(date) + ` ${hours}:${minutes}:${seconds}`;
        },

        dateToPrettyView(date) {
            let { month, day }     = this.getYMD(date);
            let { hours, minutes } = this.getHMS(date);

            return `${day} ${this.monthName[Number(month)]} в ${hours}:${minutes}`;
        },
    },
}
